import styled from 'styled-components';
import Container from 'components/Container';
import { P, H3 } from 'components/Typography';
import { sizes } from 'style';
import { th } from 'style/theme';

export const HospitalSearchContainer = styled(Container)`
  color: ${th('colors.white')};
  display: flex;
  flex-direction: column;

  @media ${sizes.desktop} {
    min-height: 100vh;
  }
`;

export const Content = styled.div`
  padding-top: ${th('space.6')}px;
  display: flex;
  flex-direction: column;

  @media ${sizes.desktop} {
    flex-direction: row;
  }
`;

export const TextContainer = styled.div`
  color: ${th('colors.black')};
  max-width: 650px;
`;

export const EmText = styled(P)`
  font-style: italic;
  margin: 2em 0;
`;

export const BoldText = styled(H3)`
  font-weight: bold;
  font-size: 1.17em;
  margin: 1em 0;
`;

export const Text = styled.div`
  margin: 2em 0;
`;

export const Illustration = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  max-width: 300px;

  @media ${sizes.tabletPortrait} {
    max-width: 350px;
    margin-left: 40px;
  }

  @media ${sizes.extraLargeDesktop} {
    position: absolute;
    bottom: 100px;
    right: 100px;
    margin: 0;
  }

  > img {
    width: 100%;
    height: auto;
  }
`;

export const Logo = styled.div`
  max-width: 300px;
  margin: 1em 0;

  > img {
    width: 100%;
    height: auto;
  }
`;
